import PropTypes from 'prop-types';

const buttonPropTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
  customClass: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default buttonPropTypes;
